module.exports = __webpack_public_path__ + "static/logo-cdp-be370479646e1a685742d8ac547a2f41.png";